import AppStorage from "./config/AppStorage";

export default class Labels {
    static availables = ["EN", "PT"];
    static values = {
        "version": {
            "current": () => { return typeof window.AppSettings === "object" && window.AppSettings != null && typeof window.AppSettings.version === "string" ? window.AppSettings.version : "" }
        },
        "states": {
            "loading": { "EN": "LOADING", "PT": "CARREGANDO" },
            "msg": () => { return typeof window.AppSettings === "object" && window.AppSettings != null && typeof window.AppSettings.headerwarning === "string" ? window.AppSettings.headerwarning : "" }
        },
        "error": {
            "msg": { "EN": "An error has occurred...", "PT": "Ocorreu um erro..." },
            "code": { "EN": "Error Code:", "PT": "Código do Erro:" },
        },
        "menu": {
            "howto": { "EN": "Help", "PT": "Ajuda" },
            "importation": { "EN": "Sales Import", "PT": "Importação de Vendas" },
            "lgpd": { "EN": "LGPD Settings", "PT": "LGPD Configurações" },
            "login": { "EN": "Login", "PT": "Acesso" },
            "dashboard": { "EN": "Pending Tasks", "PT": "Atividades Pendentes" },
            "brands": { "EN": "Brands", "PT": "Marcas" },
            "brandDetail": { "EN": "Brand Details", "PT": "Detalhes da Marca" },
            "attributes": { "EN": "Treatment Type", "PT": "Tipo de Tratamento" },
            "actionplans": { "EN": "Action plan", "PT": "Plano de Ação" },
            "brandsgroup": { "EN": "Trade Product Group", "PT": "Grupo de Produto" },
            "product": { "EN": "Trade Product", "PT": "Produto" },
            "clients": { "EN": "Franchisee and Customers", "PT": "Franqueados e Clientes" },
            "franchisee": { "EN": "Franchisee", "PT": "Franqueados" },
            "providers": { "EN": "Providers", "PT": "Fornecedores" },
            "provider": { "EN": "Provider", "PT": "Fornecedor" },
            "newfranchisee": { "EN": "New Franchisee", "PT": "Novo Franqueado" },
            "newprogram": { "EN": "New Program", "PT": "Novo Programa" },
            "programgoals": { "EN": "Participants", "PT": "Participantes" },
            "result": { "EN": "Result", "PT": "Resultado" },
            "programgoal": { "EN": "Purchase Goal", "PT": "Meta de Compra" },
            "campaigns": { "EN": "Campaigns", "PT": "Campanhas" },
            "campaign": { "EN": "Campaign", "PT": "Campanha" },
            "totalgoal": { "EN": "Purchase Progression", "PT": "Evolução Compras" },
            "programrefund": { "EN": "Prize Usage", "PT": "Uso do Prêmio" },
            "program": { "EN": "Program", "PT": "Programa" },
            "programs": { "EN": "Incentive Programs", "PT": "Programas de Incentivo" },
            "myuser": { "EN": "My User", "PT": "Meu Usuário" },
            "user": { "EN": "User Detail", "PT": "Detalhes do Usuário" },
            "clientnew": { "EN": "New Customer", "PT": "Novo Cliente" },
            "client": { "EN": "Company Details", "PT": "Detalhes da Empresa" },
            "404": { "EN": "Not Found", "PT": "Não Encontrada" },
            "401": { "EN": "Not Authorized", "PT": "Não Autorizada" },
            "admin": { "EN": "System Configuration", "PT": "Configurações de Sistema" },
            "password": { "EN": "New Password", "PT": "Nova Senha de Acesso" },
            "adminusers": { "EN": "System Users", "PT": "Usuários do Sistema" },
            "stategroupdetail": { "EN": "Regional Details", "PT": "Detalhes da Regional" },
            "qualitativeaward": { "EN": "Qualitative Prize", "PT": "Prêmio Qualitativo" },
            "stategroups": { "EN": "Regionals", "PT": "Regionais" },
            "stategroup": { "EN": "Regional", "PT": "Regional" },
        },
        "campaign": {
            "new": { "EN": "New Campaign", "PT": "Nova Campanha" },
            "newcode": { "EN": "New Campaign Code", "PT": "Novo Código" },
            "calculation": { "EN": "Goal Calculation", "PT": "Cálculo da Meta" },
            "code": { "EN": "Code", "PT": "Código" },
            "included": { "EN": "Counts as goal, but not as prize:", "PT": "Totaliza meta, mas não o prêmio:" },
            "excluded": { "EN": "Does not count towards goal or prize", "PT": "Não conta na meta nem prêmio" },
            "campaing_type_true": { "EN": "Does not count towards goal or prize calculation", "PT": "Não contabiliza na meta nem no cálculo do prêmio" },
            "campaing_type_false": { "EN": "Counts in the goal, but not in the calculation of the prize", "PT": "Contabiliza na meta, mas não no cálculo do prêmio" },
            "nocode": { "EN": "This rule doesn't have any codes.", "PT": "Esta regra não possui nenhum código." },
            "codes": { "EN": "Campaign Codes", "PT": "Códigos da Campanha" }
        },
        "provider": {
            "new": { "EN": "New Provider", "PT": "Novo Fornecedor" },
        },
        "program": {
            "expiredAccept": { "EN": "This program already reached its acceptance date limit.", "PT": "Este programa já atingiu seu limite de data de aceite." },
            "alreadyuser": { "EN": "This email address is used by another existing user. Change your email and try again. If necessary, contact customer service to complete this request.", "PT": "Esse endereço de e-mail é utilizado por outro usuário existente. Altere o e-mail e tente novamente. Se necessário, contate o atendimento ao cliente para completar essa solicitação." },
            "sameuser": { "EN": "It is not possible to assign a new responsibility to your own user. Contact Customer Service to complete this request.", "PT": "Não é possível atribuir uma nova responsabilidade para o seu próprio usuário. Contate o Atendimento ao Cliente para completar essa solicitação." },
            "goalwarning": { "EN": "Partial result of purchases in relation to the target, wait for final calculation", "PT": "Resultado parcial das compras em relação a meta, aguardar apuração final" },
            "report": { "EN": "Reports", "PT": "Relatórios" },
            "reportfranchisee": { "EN": "Customers by Franchisee", "PT": "Clientes por Franqueado" },
            "rangestart": { "EN": "More than ", "PT": "Maior que " },
            "range": { "EN": ", up to", "PT": ", até" },
            "seller": { "EN": "Seller", "PT": "Vendedor" },
            "points": { "EN": "Points", "PT": "Pontos" },
            "agreementletterfile": { "EN": "agreement_letter", "PT": "carta_acordo" },
            "downloadagreementletter": { "EN": "Agreement Letter", "PT": "Carta Acordo" },
            "reseller": { "EN": "Reseller", "PT": "Revendedor" },
            "campaign": { "EN": "Campaigns", "PT": "Campanhas" },
            "valueperpoint": { "EN": "Value per Point", "PT": "Valor por Ponto" },
            "confirmdelrule": { "EN": "Are you sure you want to delete this rule? This action cannot be undone.", "PT": "Tem certeza que deseja excluir essa regra? Essa ação não pode ser desfeita." },
            "deleterule": { "EN": "Delete Rule", "PT": "Deletar regra" },
            "deleteprogram": { "EN": "Delete Program", "PT": "Deletar Programa" },
            "deletegoal": { "EN": "Delete Goal", "PT": "Deletar Meta" },
            "deleteinvoice": { "EN": "Delete Invoice", "PT": "Deletar Nota" },
            "description": { "EN": "Description", "PT": "Descrição" },
            "nodescription": { "EN": "No Description", "PT": "Sem Descrição" },
            "goalmulti": { "EN": "Multiplier", "PT": "Multiplicador" },
            "resume": { "EN": "Brief", "PT": "Resumo" },
            "mainprizetype": { "EN": "Prize Factor", "PT": "Fator do Prêmio" },
            "maxvalue": { "EN": "Max Value", "PT": "Valor Máximo" },
            "checkusers": { "EN": "Check Users", "PT": "Verificar Usuários" },
            "minvalue": { "EN": "Minimum Value", "PT": "Valor Mínimo" },
            "prizeseller": { "EN": " Points per bag", "PT": " Pontos por saco" },
            "mainprizetype_1": { "EN": " Reais(R$) per bag", "PT": " Reais por saco" },
            "mainprizetype_2": { "EN": "% of billing", "PT": "% do faturamento" },
            "type": { "EN": "Type", "PT": "Tipo" },
            "fromgoal": { "EN": "From Goal", "PT": "Da Meta" },
            "type_true": { "EN": "Seller's Prize", "PT": "Prêmio do Vendedor" },
            "type_false": { "EN": "Main Prize", "PT": "Prêmio Principal" },
            "productspart": { "EN": "Participant Products", "PT": "Produtos Participantes" },
            "productrelation": { "EN": "Products Relation", "PT": "Relação de Produtos" },
            "programrulessec": { "EN": "Secundary Rules", "PT": "Regras Secundárias" },
            "info": { "EN": "Program Information", "PT": "Informações do Programa" },
            "name": { "EN": "Program Name", "PT": "Nome do programa" },
            "programrules": { "EN": "Program Rules", "PT": "Regras do programa" },
            "newprogramrules": { "EN": "Create Program Rules", "PT": "Criar Regras do programa" },
            "newprogramrulessec": { "EN": "Create Secundary  Rules", "PT": "Criar Regras Secundárias" },
            "programrule": { "EN": "Program Rule", "PT": "Regra do programa" },
            "qatype": { "EN": "Calculation Factor", "PT": "Fator do Cálculo" },
            "clientinfo": { "EN": "Customer Information", "PT": "Informações do Cliente" },
            "percentualgrow": { "EN": "Percent Growth", "PT": "Percentual de Crescimento" },
            "minimumbill": { "EN": "Minimum Billing", "PT": "Faturamento Mínimo" },
            "prize": { "EN": "Prize", "PT": "Prêmio" },
            "goalpercentage": { "EN": "Max Goal Percentage", "PT": "Porcentagem Máxima da Meta" },
            "reward": { "EN": "Program's Reward", "PT": "Recompensa do Programa" },
            "newreward": { "EN": "New Reward", "PT": "Nova Recompensa" },
            "newrule": { "EN": "New Rule", "PT": "Nova Regra" },
            "devolutionshow": { "EN": "Maximum Return", "PT": "Devolução Máxima" },
            "billingshow": { "EN": "Minimum Billing", "PT": "Faturamento Mínimo" },
            "billing": { "EN": "Billing Type", "PT": "Tipo de Faturamento" },
            "devolution": { "EN": "Return Type", "PT": "Tipo de Devolução" },
            "period": { "EN": "Billing Period", "PT": "Período de Faturamento" },
            "hierarchy": { "EN": "Participant", "PT": "Participante" },
            "hierarchy_true": { "EN": "Head Office", "PT": "Matriz" },
            "hierarchy_false": { "EN": "Branch", "PT": "Filial" },
            "newgoal": { "EN": "Add Participant", "PT": "Incluir Participante" },
            "uvalue": { "EN": "Unity Value", "PT": "Valor Unitário" },
            "paymenttype": { "EN": "Payment Type", "PT": "Tipo de Pagamento" },
            "quantity": { "EN": "Quantity", "PT": "Quantidade" },
            "evdate": { "EN": "Event Date", "PT": "Data do Evento" },
            "action": { "EN": "Action", "PT": "Ação" },
            "lastupdate": { "EN": "Last Update", "PT": "Última Atualização" },
            "newfile": { "EN": "New File", "PT": "Novo Arquivo" },
            "edit": { "EN": "Edit", "PT": "Editar" },
            "refund": { "EN": "Attach Files", "PT": "Incluir Arquivos" },
            "qualitativeawardf": { "EN": "Notas Fiscais", "PT": "Notas Fiscais" },
            "qualitativeaward": { "EN": "Qualitative Prize", "PT": "Prêmio Qualitativo" },
            "franchiseeresults": { "EN": "Results", "PT": "Resultado" },
            "fundsused": { "EN": "Action Plan", "PT": "Plano de Ação" },
            "alterstatus": { "EN": "Do you confirm?", "PT": "Você confirma?" },
            "actionplan": { "EN": "Action Plan", "PT": "Plano de Ação" },
            "newactionplan": { "EN": "New Action Plan", "PT": "Novo Plano de Ação" },
            "programgoal": { "EN": "Purchase Goals", "PT": "Metas de Compra" },
            "parameters": { "EN": "Parameters", "PT": "Parâmetros" },
            "chronogram": { "EN": "Schedule", "PT": "Cronograma" },
            "program": { "EN": "Program", "PT": "Programa" },
            "waitingaccept": { "EN": "To fill this item, the Client must accept the program terms.", "PT": "Para preencher este item, é necessário que o Cliente realize o aceite dos termos do programa." },
            "programinfo": { "EN": "Program Information", "PT": "Informações do Programa" },
            "info": { "EN": "Information", "PT": "Informações" },
            "norule": { "EN": "This program doesn't have any rules.", "PT": "Este programa não possui nenhuma regra." },
            "norewards": { "EN": "This rule doesn't have any rewards.", "PT": "Esta regra não possui nenhuma recompensa." },
            "nochronogram": { "EN": "Schedule not Configured", "PT": "Cronograma não configurado." },
            "confirmation": { "EN": "I declare that I have read and agree to the terms of the program.", "PT": "Declaro que li e estou de acordo com os termos do programa." },
            "statement": { "EN": "Customer Statement", "PT": "Extrato do Cliente" },
            "result": { "EN": "Result", "PT": "Resultado" },
            "resulttable": { "EN": "Result Table", "PT": "Tabela Resultado" },
            "insertresult": { "EN": "Insert Result", "PT": "Inserir Resultados" },
            "customerresult": { "EN": "Customer Result", "PT": "Resultado do Cliente" },
            "editresult": { "EN": "Edit Result", "PT": "Editar Resultado" },
            "checkuserwarning_46": {
                "EN": "Click on \"New User\" to register the Focal Point. At least one user is required. If a user is out of date, select  it from the list to change it. If everything is correct, click \"Confirm\".",
                "PT": "Clique em “Novo Usuário” para cadastrar o Focal Point. É necessário, no mínimo, um usuário. Caso um usuário esteja desatualizado, selecione da lista o que deseja alterar. Se tudo estiver correto, clique em \"Confirmar\"."
            },
            "checkuserwarning_47": {
                "EN": "Click on \"New User\" to register the Legal Representative. At least one user is required. If a user is out of date, select it from the list to change it. If everything is correct, click \"Confirm\".",
                "PT": "Clique em “Novo Usuário” para cadastrar o Representante Legal. É necessário, no mínimo, um usuário. Caso um usuário esteja desatualizado, selecione da lista o que deseja alterar. Se tudo estiver correto, clique em \"Confirmar\"."
            },
            "checkuserwarning": {
                "EN": "Check the information of registered users. At least one user is required and your information must have been entered recently. If a user is out of date (their information has been informed for more than six months), select from the list what you want to change or create a new one. If everything is correct, click \"confirm\".",
                "PT": "Verifique as informações dos usuários cadastrados. É necessário no mínimo um usuário e suas informações devam ter sido informadas recentemente. Caso um usuário esteja desatualizado (suas informações podem ter sido informadas a mais de seis meses), selecione da lista o que deseja alterar ou crie um novo. Se tudo estiver correto, clique em \"confirmar\"."
            },
            "owneronly": {
                "EN": "Only the owner of this company can accept the terms of the program!",
                "PT": "Apenas o proprietário desta empresa pode aceitar os termos do program!"
            }
        },
        "program_state": {
            "nousers": { "EN": "No registered users", "PT": "Nenhum usuário cadastrado" },
            "nousersdesc": {
                "EN": "The release of the goal and the participation of the customer is only possible when at least the Focal Point is registered",
                "PT": "Só é possível a liberação da meta e a participação do Cliente quando pelo menos o Focal Point estiver cadastrado."
            },
            "nofocalpoint": { "EN": "Missing key users", "PT": "Usuários-chave ausentes" },
            "nofocalpointdesc": {
                "EN": "It is only possible to release the target and the Client's participation when both, Focal Point and Legal Representative, are registered.",
                "PT": "Só é possível a liberação da meta e a participação do Cliente quando ambos, o Focal Point e Representante Legal, estiverem cadastrados."
            },
            "noactionplan": { "EN": "Action plan not registered", "PT": "Plano de ação não cadastrado" },
            "noactionplandesc": {
                "EN": "This customer will only be able to submit reimbursement requests for use of the qualitative award when at least one action plan is registered",
                "PT": "Esse cliente só poderá submeter as solicitações de reembolso para utilização do prêmio qualitativo quando no mínimo um plano de ação estiver cadastrado"
            },
            "norules": { "EN": "This program doesn't have any rules.", "PT": "Este programa não possui nenhuma regra." },
            "norulesdesc": {
                "EN": "It is necessary that this program is complete before it can be released.",
                "PT": "É necessário que este programa esteja completo para que possa ser liberado."
            },
            "nochronogram": { "EN": "This program doesn't have a schedule.", "PT": "Este programa não possui um cronograma." },
            "nochronogramdesc": {
                "EN": "It is necessary that this program is complete before it can be released.",
                "PT": "É necessário que este programa esteja completo para que possa ser liberado."
            },
            "noqaward": { "EN": "This program has no qualitative program rules yet.", "PT": "Este programa ainda não tem regras do programa qualitativo." },
            "noqawarddesc": {
                "EN": "It is necessary that this program is complete before it can be released.",
                "PT": "É necessário que este programa esteja completo para que possa ser liberado."
            },
        },
        "program_refund": {
            "refundinfo": { "EN": "Payment Information", "PT": "Informações de Pagamento" },
            "accountAgency": { "EN": "Agency", "PT": "Agência" },
            "receipt": { "EN": "Transfer receipt", "PT": "Comprovante da transferência " },
            "accountBank": { "EN": "Bank Name", "PT": "Nome do Banco" },
            "accountNumber": { "EN": "Account Number", "PT": "Número da Conta" },
            "accountType": { "EN": "Account Type", "PT": "Tipo da Conta" },
            "invoicevalue": { "EN": "Invoice Value", "PT": "Valor da Nota" },
            "ActionPlan": { "EN": "Action Plan", "PT": "Plano de Ação" },
            "InvoiceType": { "EN": "Invoice Type", "PT": "Tipo de Nota" },
            "Title": { "EN": "Product / Service", "PT": "Natureza Produto/Serviço" },
            "MainKeyCriticalType": { "EN": "Issuer Document Type", "PT": "Tipo de Documento do Emissor" },
            "DatetimeEmission": { "EN": "Emission Date", "PT": "Data de Emissão" },
            "criticalValue": { "EN": "Issuer Document", "PT": "Documento do Emissor" },
            "Indentificator": { "EN": "Invoice Number", "PT": "Número da Nota" },
            "Issuer": { "EN": "Issuer Name", "PT": "Razão Social/Nome do Emissor" },
            "Kind": { "EN": "Kind", "PT": "Tipo" },
            "Series": { "EN": "Series", "PT": "Série" },
            "ValueTotal": { "EN": "Total Value", "PT": "Valor Total" },
            "investmenttotal": { "EN": "Maximum Investment", "PT": "Investimento Máximo" },
            "investmentused": { "EN": "Investment Used", "PT": "Investimento Utilizado" },
            "investmentavailable": { "EN": "Investment Available", "PT": "Investimento Disponível" },
            "ValueTotal": { "EN": "Total Value", "PT": "Valor Total" },
            "unityvalue": { "EN": "Unitary value", "PT": "Valor Unitário" },
            "usedvalue": { "EN": "Used value", "PT": "Valor Utilizado" },
            "actiondate": { "EN": "Action Date", "PT": "Data da Ação" },
            "unity": { "EN": "Amount", "PT": "Quantidade" },
            "file": { "EN": "Attach Invoice", "PT": "Anexar Nota fiscal" },
            "file2": { "EN": "Attach Evidence 01", "PT": "Anexar Evidencia 01" },
            "file3": { "EN": "Attach Evidence 02", "PT": "Anexar Evidencia 02" },
            "worksheet": { "EN": "Attach Worksheet", "PT": "Anexar Planilha" },
            "checkbox": { "EN": "Activate Checkbox", "PT": "Ativar Checkbox" },
            "disputecase": { "EN": "It is necessary to inform the payment identification number in the field below", "PT": "É necessário informar no campo abaixo o número de identificação do pagamento" },
            "Obs": { "EN": "Observation", "PT": "Observação" },
            "usedavailable": { "EN": "Used / Available", "PT": "Utilizado / Disponível" },
            "emptyinvoice": { "EN": "This award has not yet been used.", "PT": "Este prêmio ainda não foi utilizado." },
            "required": { "EN": "You must submit at least one file of this type to request approval for this document.", "PT": "É preciso submeter pelo menos um arquivo deste tipo para solicitar a aprovação deste documento." },
            "requiredtitle": { "EN": "Missing File", "PT": "Arquivo Ausente" },
            "filenot": { "EN": "The date for sending the file has expired.", "PT": "A data para o envio do arquivo foi expirada." },
            "filenot2": {
                "EN": "Review the attachments: it is necessary to send the Invoice and at least two pieces of evidence to continue.",
                "PT": "Revise os anexos: é necessário o envio da Nota Fiscal e, no mínimo, duas evidências para continuar."
            },
            "filenot3": { "EN": "You cannot reinsert this document.", "PT": "Não é possível inserir este documento novamente." },
        },
        "program_refund_type": {
            "1": { "EN": "Invoice", "PT": "Nota Fiscal" },
            "2": { "EN": "Evidence", "PT": "Evidências" },
            "3": { "EN": "Photo", "PT": "Foto" },
            "4": { "EN": "Attendance list", "PT": "Lista de Presença" },
            "5": { "EN": "Payment Voucher", "PT": "Comprovante de Pagamento" }
        },
        "program_schedule": {
            "program": { "EN": "Program Term", "PT": "Vigência do Programa" },
            /************************************** MUDEI O Validity of Points PARA Points Expiration **************************************/
            "points": { "EN": "Points Expiration", "PT": "Validade dos Pontos" },
            /************************************** MUDEI O Validity of Points PARA Points Expiration **************************************/
            "accept": { "EN": "Program Acceptance", "PT": "Aceite do Programa" },
            "launch": { "EN": "Invoice Entry (Qualitative Award)", "PT": "Lançamento da NF (Premio Qualitativo)" },
            "buy": { "EN": "Purchase", "PT": "Compra" },
            "devtotal": { "EN": "Total Return", "PT": "Devolução Total" },
            "buypremium": { "EN": "TSI Return", "PT": "Devolução TSI" },
            "histbui": { "EN": "Purchase History", "PT": "Histórico Compra" },
            "histdev": { "EN": "Purchase Return History", "PT": "Hist. Devolução Compra" },
            "qa": { "EN": "Qualitative Award Plan", "PT": "Plano Prêmio Qualitativo" }
        },
        "login": {
            "header": { "EN": "My Credentials", "PT": "Minhas Credenciais" },
            "btn": { "EN": "Login", "PT": "Entrar" },
            "user1": { "EN": "Customers", "PT": "Clientes" },
            "user2": { "EN": "LongPing Employees", "PT": "Colaboradores LongPing" },
            "user": { "EN": "User e-mail", "PT": "E-mail do usuário" },
            "password": { "EN": "Password", "PT": "Senha" },
            "error": { "EN": "Error", "PT": "Erro" },
            "error400": { "EN": "Error, please try again.", "PT": "Erro, tente novamente." },
            "error204": { "EN": "Invalid credentials, please try again.", "PT": "Credenciais inválidas, tente novamente." },
            "error401": { "EN": "Invalid credentials, please try again.", "PT": "Credenciais inválidas, tente novamente." },
            "error402": { "EN": "New user, use the instructions sent by system or request a new password to access.", "PT": "Novo usuário, utilize as instruções enviadas por sistema ou solicite uma nova senha para realizar o acesso." },
            "error403": { "EN": "The user does not have permissions to use this system.", "PT": "O usuário não possui permissões para utilizar este sistema." },
            "error404": { "EN": "Invalid credentials, please try again.", "PT": "Credenciais inválidas, tente novamente." },
            "error406": { "EN": "Access temporarily disabled. Request a new password to access.", "PT": "Acesso temporariamente desabilitado. Solicite uma nova senha para realizar o acesso." },
            "loader": { "EN": "Validating...", "PT": "Validando..." }
        },
        "clients": {
            "newheader": { "EN": "New Business Customer", "PT": "Novo Cliente" },
            "newlabel": { "EN": "Customer Name", "PT": "Nome do Cliente" },
            "results": { "EN": "Results", "PT": "Resultados" },
            "pesquisar": { "EN": "Search", "PT": "Pesquisar" },
            "social": { "EN": "Company Name", "PT": "Razão Social" },
            "id": { "EN": "Identificator", "PT": "Identificador" },
            "nfatasy": { "EN": "Fantasy Name", "PT": "Nome Fantasia" },
            "savebtn": { "EN": "Create", "PT": "Criar" },
            "closebtn": { "EN": "Cancel", "PT": "Cancelar" },
            "empty": { "EN": "No customer found....", "PT": "Nenhum cliente encontrado..." },
        },
        "userhistory": {
            "history": { "EN": "History", "PT": "Histórico" },
            "name": { "EN": "Name User", "PT": "Nome Usuário" },
            "email": { "EN": "Email User", "PT": "Email Usuário" },
            "modifiedname": { "EN": "Modified Name", "PT": "Nome Modificado" },
            "cpfnew": { "EN": "New CPF", "PT": "CPF Novo" },
            "cpfold": { "EN": "Old CPF", "PT": "CPF Antigo" },
            "modifiedemail": { "EN": "Modified Email", "PT": "Email Modificado" },
            "datetimeregister": { "EN": "Datetime Register", "PT": "Data de Registro" },
            "datetimeupdate": { "EN": "Datetime Update", "PT": "Data de Alteração" },
            "status": { "EN": "Status", "PT": "Status" },
            "closebtn": { "EN": "Close", "PT": "Fechar" },
        },
        "clientdetail": {
            "usersheader": { "EN": "Users", "PT": "Usuários" },
            "role": { "EN": "User Role", "PT": "Papel do Usuário" },
            "newUser": { "EN": "New User", "PT": "Novo Usuário" },
            "edituser": { "EN": "Edit User", "PT": "Editar Usuário" },
            "newnumber": { "EN": "Register Value", "PT": "Valor do Registro" },
            "email": { "EN": "E-Mail Address", "PT": "Endereço de E-Mail" },
            "newaddress": { "EN": "New Address", "PT": "Novo Endereço" },
            "street": { "EN": "Address", "PT": "Endereço" },
            "streetnumb": { "EN": "Number", "PT": "Número" },
            "streetcomplement": { "EN": "Complement", "PT": "Complemento" },
            "streetneigh": { "EN": "District", "PT": "Bairro" },
            "streetstate": { "EN": "State", "PT": "Estado" },
            "streetcity": { "EN": "City", "PT": "Cidade" },
            "streetcode": { "EN": "Zipcode", "PT": "CEP" },
            "username": { "EN": "User Name", "PT": "Nome do Usuário" },
            "usercpf": { "EN": "User CPF", "PT": "CPF do Usuário" },
        },
        "clientsnew": {
            "newpassword": { "EN": "Password Registration", "PT": "Cadastramento de Senha" },
            "confirmationheader": { "EN": "New Customer", "PT": "Novo Cliente" },
            "franchiseeHeader": { "EN": "New Franchisee", "PT": "Novo Franqueado" },
            "confirmation": { "EN": "Do you confirm that the information provided is correct?", "PT": "Você confirma que as informações fornecidas estão corretas?" },
            "infoheader": { "EN": "Customer Information", "PT": "Informações do Cliente" },
            "regionheader": { "EN": "Business Region", "PT": "Região de Negócio" },
            "contactheader": { "EN": "Contact Information", "PT": "Informações de Contato" },
            "doctype": { "EN": "Document Type", "PT": "Tipo do Documento" },
            "brandname": { "EN": "Brand", "PT": "Marca" },
            "docnumb": { "EN": "Document Number", "PT": "Número do Documento" },
            "name": { "EN": "Customer's Name", "PT": "Nome do Cliente" },
            "street": { "EN": "Address", "PT": "Endereço" },
            "streetnumb": { "EN": "Number", "PT": "Número" },
            "streetneigh": { "EN": "District", "PT": "Bairro" },
            "streetcode": { "EN": "Zipcode", "PT": "CEP" },
            "phone": { "EN": "Telephone number", "PT": "Telefone do Contato" },
            "email": { "EN": "E-Mail Address", "PT": "Endereço de E-Mail" }
        },
        "adminuserpage": {
            "newheader": { "EN": "New AD User", "PT": "Novo Usuário do AD" },
            "newlabel": { "EN": "User name", "PT": "Nome de usuário" },
            "savebtn": { "EN": "Save", "PT": "Salvar" },
            "closebtn": { "EN": "Cancel", "PT": "Cancelar" },
            "saving": { "EN": "Processing request...", "PT": "Processando requisição.." },
        },
        "companydetail": {
            "addressheader": { "EN": "Company Addresses", "PT": "Endereços da Empresa" },
            "telephoneheader": { "EN": "Company Telephones", "PT": "Telefones da Empresa" },
            "newlabel": { "EN": "User name", "PT": "Nome de usuário" },
            "savebtn": { "EN": "Save", "PT": "Salvar" },
            "closebtn": { "EN": "Cancel", "PT": "Cancelar" },
            "saving": { "EN": "Processing request...", "PT": "Processando requisição.." },
        },
        "adminstategroup": {
            "newheader": { "EN": "New Regional", "PT": "Nova Regional" },
            "newlabel": { "EN": "Regional Name", "PT": "Nome da Regional" },
            "savebtn": { "EN": "Save", "PT": "Salvar" },
            "sendbtn": { "EN": "Send", "PT": "Enviar" },
            "closebtn": { "EN": "Cancel", "PT": "Cancelar" },
            "saving": { "EN": "Processing request...", "PT": "Processando requisição.." },
        },
        "adminstategroupdetail": {
            "empty": { "EN": "No items currently available...", "PT": "Nenhum item disponível no momento..." },
            "EMPLOYEE_FRANCHISEE_listing3": { "EN": "Results", "PT": "Resultados" },
            "EMPLOYEE_FRANCHISEE_listing2": { "EN": "Signaling", "PT": "Assinalamento" },
            "EMPLOYEE_FRANCHISEE_listing": { "EN": "Franchises", "PT": "Franquias" },
            "EMPLOYEE_FRANCHISEE": { "EN": "Franchisee", "PT": "Franqueado" },
            "EMPLOYEE_AREA_LEADER": { "EN": "Sales Leader", "PT": "Lider de Vendas" },
            "EMPLOYEE_REGION_BRAND_MANAGER": { "EN": "Regional Marketing Manager", "PT": "Gerente de Marketing Regional" },
            "newlabel": { "EN": "Responsible", "PT": "Responsável" },
            "EMPLOYEE_FRANCHISE_MANAGER": { "EN": "Franchise Manager", "PT": "Gerente de Franquia" },
        },
        "userdetail": {
            "informationheader": { "EN": "User information", "PT": "Informações do Usuário" },
        },
        "myuser": {
            "options": { "EN": "Options", "PT": "Opções" },
            "company": { "EN": "Company", "PT": "Empresa" },
            "register": { "EN": "Register", "PT": "Registro" },
            "username": { "EN": "Name", "PT": "Nome" },
            "password": { "EN": "Change Password", "PT": "Alterar Senha" },
            "edit": { "EN": "Edit Information", "PT": "Editar Informações" },
            "signout": { "EN": "Sign-out", "PT": "Sair da Conta" },
            "email": { "EN": "E-Mail" }
        },
        "admin": {
            "options": { "EN": "Options", "PT": "Opções" },
            "company": { "EN": "Company", "PT": "Empresa" },
            "register": { "EN": "Register", "PT": "Registro" },
            "username": { "EN": "Name", "PT": "Nome" },
            "password": { "EN": "Change Password", "PT": "Alterar Senha" },
            "users": { "EN": "System Users", "PT": "Usuários de Sistema" },
            "signout": { "EN": "Sign-out", "PT": "Sair da Conta" },
            "email": { "EN": "E-Mail" }
        },
        "information":
        {
            "AD_DOMAIN": { "EN": "AD Login", "PT": "Login do AD" },
            "DOC_CNPJ": { "EN": "CNPJ Number", "PT": "Número do CNPJ" },
            "DATE_BIRTH": { "EN": "Birth Date", "PT": "Data de Nascimento" },
            "DOC_RG": { "EN": "RG Number", "PT": "Número de RG" },
            "DOC_RURAL": { "EN": "Rural Registration", "PT": "Inscrição Rural" },
            "DOC_CPF": { "EN": "CPF Number", "PT": "Número do CPF" },
            "TEL_MOBILE": { "EN": "Mobile Phone", "PT": "Telefone Celular" },
            "TEL_RESIDENTIAL": { "EN": "Residential Phone", "PT": "Telefone Residencial" },
            "TEL_WORK": { "EN": "Commercial Phone", "PT": "Telefone Comercial" },
            "NAME_USER": { "EN": "User Name", "PT": "Nome do Usuário" },
            "NAME_TITLE": { "EN": "Job Title", "PT": "Cargo" },
            "NAME_MOTHER": { "EN": "Mother's Name", "PT": "Nome da Mãe" },
            "WEBSITE": { "EN": "Website", "PT": "Website" },
            "EMAIL_PRIMARY": { "EN": "Primary E-Mail", "PT": "E-Mail Primário" },
            "EMAIL_CONTACT": { "EN": "Contact E-Mail", "PT": "E-Mail de Contato" },
            "PASSWORD": { "EN": "Password", "PT": "Senha" },
            "REGISTER": { "EN": "Employee Number", "PT": "Número de Matrícula" },
            "GUID": { "EN": "GUID", "PT": "GUID" },
            "DEPARTAMENT": { "EN": "Department", "PT": "Departamento" },
            "ADDRESS_RESIDENCE": { "EN": "Residential Address", "PT": "Endereço Residencial" },
            "ADDRESS_BILLING": { "EN": "Billing Address", "PT": "Endereço de Faturamento" },
            "ADDRESS_WORK": { "EN": "Commercial Address", "PT": "Endereço Comercial" },
            "ADDRESS_MAIL": { "EN": "Mail Box", "PT": "Endereço de Correspondência" }
        },
        "UNIT_TYPE":
        {
            "1": { "EN": "Quantity", "PT": "Quantidade" },
            "2": { "EN": "Goal Percentage", "PT": "Percentual da Meta" },
            "3": { "EN": "Value Percentage", "PT": "Percentual do Valor" },
            "4": { "EN": "Percentage of Total Bags Purchased", "PT": "Percentual Sobre o Total de Sacos Comprados" },
            "5": { "EN": "Percentage of Billed Volume", "PT": "Percentual de Volume Faturado" }
        },
        "UNIT_TYPE_UNIT":
        {
            "1": { "EN": " Bags", "PT": " Sacos" },
            "2": { "EN": "%", "PT": "%" },
            "3": { "EN": "%", "PT": "%" },
            "4": { "EN": "%", "PT": "%" },
            "5": { "EN": "%", "PT": "%" }
        },
        "invoice_type":
        {
            "NOTA_FISCAL": { "EN": "Invoice", "PT": "Nota Fiscal" },
            "CUPOM_FISCAL": { "EN": "Tax Coupon", "PT": "Cupom Fiscal" },
            "RECIBO_PAPEL": { "EN": "Paper Receipt", "PT": "Recibo de Papel" }
        },
        "PRODUCT_RELATIONSHIP":
        {
            "1": { "EN": "All Products", "PT": "Todos os Produtos" },
            "2": { "EN": "All, except these produtcs:", "PT": "Todos, exceto estes produtos:" },
            "3": { "EN": "Only these products:", "PT": "Apenas estes produtos:" }
        },
        "PROGRAM_RULE_PRIZE_TYPE":
        {
            "1": { "EN": "Reais per Bag", "PT": "Reais por Saco" },
            "2": { "EN": "Billing Percentage", "PT": "Porcentagem Faturamento" }
        },
        "program_payment_type":
        {
            "1": { "EN": "Direct Payment", "PT": "Pagamento de Fornecedor" },
            "2": { "EN": "Customer Refund", "PT": "Reembolso de Cliente" }
        },
        "program_period_type":
        {
            "1": { "EN": "Total", "PT": "Total" },
            "2": { "EN": "Monthly", "PT": "Mensal" }
        },
        "qualitative_award_type":
        {
            "1": { "EN": "Purchase Goal Quantity", "PT": "Quantidade da Meta de Compra" },
            "2": { "EN": "Purchase History", "PT": "Histórico de Compra" }
        },
        "program_billing_type":
        {
            "1": { "EN": "Quantity", "PT": "Quantidade" },
            "2": { "EN": "Value", "PT": "Valor" }
        },
        "information_inputtype":
        {
            "DOC_CNPJ": "cnpj",
            "DATE_BIRTH": "date",
            "DOC_RG": "rg",
            "DOC_CPF": "cpf",
            "TEL_MOBILE": "tel",
            "TEL_RESIDENTIAL": "tel",
            "TEL_WORK": "tel",
            "NAME_USER": "fname",
            "NAME_MOTHER": "fname",
            "WEBSITE": "url",
            "EMAIL_PRIMARY": "email",
            "EMAIL_CONTACT": "email"
        },
        "permission": {
            "CUSTOMER_USER": { "EN": "Focal Point" },
            "CUSTOMER_ADMIN": { "EN": "Legal Representative", "PT": "Representante Legal" },
            "FRANCHISEE_USER": { "EN": "Franchisee", "PT": "Franqueado" },
            "FRANCHISEE_ADMIN": { "EN": "Franchisee", "PT": "Franqueado" },
            "PROVIDER_USER": { "EN": "Fornecedor", "PT": "Fornecedor" },
            "PROVIDER_ADMIN": { "EN": "Fornecedor", "PT": "Fornecedor" },
            "INC_AREA_LEADER": { "EN": "Sales Leader", "PT": "Líder de Vendas" },
            "INC_FRANCHISE_MANAGER": { "EN": "Franchise Manager", "PT": "Gerente de Franquia" },
            "INC_SYS_ADMIN": { "EN": "System Administrator", "PT": "Administrador de Sistema" },
            "INC_SYS_MANAGER": { "EN": "System Manager", "PT": "Gerente do Sistema" },
            /**************************** MUDEI O Gerente de Marca da Região PARA Gerente de Desenvolvimento de Mercado ****************************/
            /**************************** MUDEI O Gerente de Desenvolvimento de Mercado PARA Gerente de Marketing Regional *************************/
            "INC_REGION_BRAND_MANAGER": { "EN": "Regional Marketing Manager", "PT": "Gerente de Marketing Regional" }
            /**************************** MUDEI O Gerente de Desenvolvimento de Mercado PARA Gerente de Marketing Regional *************************/
            /**************************** MUDEI O Gerente de Marca da Região PARA Gerente de Desenvolvimento de Mercado ****************************/
        },
        "brand": {
            "ProductGroup": { "EN": "New Product Group", "PT": "Novo Grupo de Produto" },
            "Attribute": { "EN": "New Treatment Type", "PT": "Novo Tipo de Tratamento" },
            "ActionPlan": { "EN": "New Action Plan", "PT": "Novo Plano de Ação" },
            "Product": { "EN": "New Trade Product", "PT": "Novo Produto" },
        },
        "branddetail": {
            "ProductGroup": { "EN": "Vinculate Product Group", "PT": "Vincular Grupo de Produto" },
            "Attribute": { "EN": "Vinculate Treatment Type", "PT": "Vincular Tipo de Tratamento" },
            "Product": { "EN": "Vinculate Trade Product", "PT": "Vincular Produto" },
        },
        "programgoal": {
            "newaward": {
                "EN": "The inclusion of a Client's participation in the Program's Qualitative Award allows the client to use incentive funds in accordance with the goals defined by the responsible Franchisee. The amount used is then reimbursed through the refund request as long as it is in accordance with the terms of use and upon approval.",
                "PT": "A inclusão da participação de um Cliente ao Prêmio Qualitativo " +
                    "do programa possibilita que o mesmo utilize verbas de incentivo destinada de acordo com as metas definidas pelo Franqueado responsável." +
                    " A verba utiliza é então reembolsada através da solicitação de reembolso desde que esteja de acordo com os termos de utilização e mediante aprovação."
            },
            "removeaward": {
                "EN": "The removal of the Qualitative Award from this Client's program makes it impossible for the client to request a refund through the system, as well as the exclusion of any data associated with the process.",
                "PT": "A remoção do Prêmio Qualitativo do programa deste Cliente impossibilita que o mesmo possa solicitar reembolso através do sistema, assim como a exclusão de qualquer dado associado ao processo."
            }
        },
        "results": {
            "headcode": { "EN": "Head Code", "PT": "Código da Matriz" },
            "clientcode": { "EN": "Client Code", "PT": "Código do Cliente" },
            "grossrevenue": { "EN": "Gross Revenue", "PT": "Faturamento Bruto" },
            "returns": { "EN": "Returns", "PT": "Devoluções" },
            "netrevenue": { "EN": "Considered Total", "PT": "Total Considerado" },
            "harvestreturns": { "EN": "Harvest Returns", "PT": "Devolução de Safra" },
            "harvestreturnsperc": { "EN": "Harvest Returns %", "PT": "% Devolução de Safra" },
            "metarule": { "EN": "Target", "PT": "Meta" },
            "metarule2": { "EN": "Achieved Target %", "PT": "% Meta Atingida" },
            "mainprizeR$SC": { "EN": "R$/SC - Main Prize", "PT": "R$/SC - Prêmio Principal" },
            "salesequivprizeR$SC": { "EN": "R$/SC - Sales Equiv. Prize", "PT": "R$/SC - Prêmio Eq. Vendas" },
            "mainprizeR$": { "EN": "R$ - Main Prize", "PT": "Prêmio Principal R$" },
            "mainprizeSC": { "EN": "SC - Main Prize", "PT": "Prêmio Principal SC" },
            "salesteamaward": { "EN": "Sales Team Award", "PT": "Prêmio Equipe de Vendas" },
            "observation": { "EN": "Observation", "PT": "Observação" },
            "notdataclient": { "EN": "It has no data for this client.", "PT": "Não possui dados para esse cliente." },
            "sacks": { "EN": "Sacks.", "PT": "Sacos" },
        },
        "generic": {
            "results": { "EN": "Results", "PT": "Resultados" },
            "bag": { "EN": "Bag", "PT": "Saco" },
            "all": { "EN": "All", "PT": "Todos" },
            "details": { "EN": "Details", "PT": "Detalhes" },
            "history": { "EN": "Historic", "PT": "Histórico" },
            "gfvalidation": { "EN": "Validation", "PT": "Validação" },
            "available": { "EN": "Available", "PT": "Disponível" },
            "selected": { "EN": "Selected", "PT": "Selecionado" },
            "start": { "EN": "Start", "PT": "Início" },
            "password": { "EN": "Password", "PT": "Senha de Acesso" },
            "accountgroup": { "EN": "Account Group", "EN": "Grupo de Contas" },
            "notinformed": { "EN": "Not informed", "PT": "Não informado" },
            "goal": { "EN": "Goal", "PT": "Meta" },
            "status2": { "EN": "Filter by Crop", "PT": "Filtrar por Safra" },
            "allstates2": { "EN": "Select the crop you'd like to view", "PT": "Selecione a safra que gostaria de visualizar" },
            "status": { "EN": "Filter Status", "PT": "Filtrar Status" },
            "allstates": { "EN": "All status", "PT": "Todos os Status" },
            "end": { "EN": "End", "PT": "Fim" },
            "file": { "EN": "File", "PT": "Arquivo" },
            "filename": { "EN": "File Name", "PT": "Nome do Arquivo" },
            "files": { "EN": "Files", "PT": "Arquivos" },
            "fillParameters": { "EN": "Fill the search parameters to find Customers.", "PT": "Preencha os campos de pesquisa para encontrar Clientes." },
            "done": { "EN": "The operation performed successfully", "PT": "A operação realizada com sucesso" },
            "delete": { "EN": "Delete Item", "PT": "Deletar Item" },
            "activate": { "EN": "Activate Item", "PT": "Ativar Item" },
            "edit": { "EN": "Editar Item", "PT": "Editar Item" },
            "confirmdel": { "EN": "Are you sure you want to delete this item? This action cannot be undone.", "PT": "Tem certeza que deseja excluir este item? Essa ação não pode ser desfeita." },
            "confirmactivate": { "EN": "Are you sure you want to activate this item?", "PT": "Tem certeza que deseja ativar este item?" },
            "sendactivate": { "EN": "File uploaded successfully!", "PT": "Arquivo enviado com sucesso!" },
            "sendnotactivate": { "EN": "The file ID is not the same as the program ID. Select the right program.", "PT": "O ID do arquivo não é igual o ID do programa. Selecione o programa certo." },
            "noresult": { "EN": "No Result", "PT": "Nenhum resultado" },
            "notselected": { "EN": "Not Selected", "PT": "Não Selecionado" },
            "clienttype": { "EN": "Customer Type", "PT": "Tipo de cliente" },
            "loading": { "EN": "Loading...", "PT": "Carregando..." },
            "registervalue": { "EN": "Register Value", "PT": "Valor do Registro" },
            "description": { "EN": "Description", "PT": "Descrição" },
            "observation": { "EN": "Observation", "PT": "Observação" },
            "street": { "EN": "Address", "PT": "Endereço" },
            "streetcode": { "EN": "Zipcode", "PT": "CEP" },
            "streetnumb": { "EN": "Number", "PT": "Número" },
            "actionplan": { "EN": "Action Plan", "PT": "Plano de Ação" },
            "actionPlans": { "EN": "Action Plans", "PT": "Planos de Ação" },
            "value": { "EN": "Value", "PT": "Valor" },
            "version": { "EN": "Version", "PT": "Versão" },
            "name": { "EN": "Name", "PT": "Nome" },
            "docnumb": { "EN": "CNPJ", "PT": "CNPJ" },
            "registertype": { "EN": "Register Type", "PT": "Tipo de Registro" },
            "newregister": { "EN": "New Register", "PT": "Novo Registro" },
            "shortreg": { "EN": "Reg", "PT": "Mat" },
            "register": { "EN": "Register", "PT": "Matrícula" },
            "state": { "EN": "State", "PT": "Estado" },
            "city": { "EN": "City", "PT": "Cidade" },
            "creation": { "EN": "Created At", "PT": "Criado Em" },
            "select": { "EN": "Select", "PT": "Selecione" },
            "signout": { "EN": "Sign-out", "PT": "Sair da Conta" },
            "results": { "EN": "Results", "PT": "Resultados" },
            "brand": { "EN": "Brand", "PT": "Marca" },
            "customercode": { "EN": "Customer Code", "PT": "Código do Cliente" },
            "payercode": { "EN": "Head Office Code", "PT": "Código da Matriz" },
            "email": { "EN": "E-Mail" },
            "confirm": { "EN": "Confirm", "PT": "Confirmar" },
            "lgpdReport": { "EN": "Download Report Accepts", "PT": "Baixar Relatório de Aceites" },
            "save": { "EN": "Save", "PT": "Salvar" },
            "request": { "EN": "Request", "PT": "Solicitar" },
            "cancel": { "EN": "Cancel", "PT": "Cancelar" },
            "searchterm": { "EN": "Search term", "PT": "Pesquisar termo" },
            "noresultfound": { "EN": "No results found", "PT": "Nenhum resultado encontrado" },
            "program": { "EN": "Program", "PT": "Programa" },
            "stategroup": { "EN": "Regional", "PT": "Regional" },
            "user": { "EN": "Customers", "PT": "Clientes" },
            "dc": { "EN": "DC", "PT": "DC" },
        },
        "CLIENT_TYPE": {
            "ZAG": { "EN": "AGRO INDUSTRY", "PT": "AGRO INDUSTRIA" },
            "ZCD": { "EN": "CO-DISTRIBUTOR", "PT": "CO-DISTRIBUIDOR" },
            "ZCO": { "EN": "COOPERATIVE", "PT": "COOPERATIVA" },
            "ZDI": { "EN": "DISTRIBUTOR", "PT": "DISTRIBUIDOR" },
            "ZEU": { "EN": "END USER", "PT": "USUÁRIO FINAL" },
            "ZFR": { "EN": "FRANCHISEE", "PT": "FRANQUEADO" },
            "ZIN": { "EN": "INSTITUTE", "PT": "INSTITUTO" },
            "ZRV": { "EN": "DEALER", "PT": "REVENDEDOR" },
        },
        "help": {
            "DESC": {
                "PT": "Contatos:<br/>Tel: 0800 772 2722<br/>E-mail: centralderelacionamento@lpht.com.br<br/><br/>Website: <a href=\"https://lpht.com.br/\">https://lpht.com.br/</a>",
                "EN": "Contacts:<br/>Tel: 0800 772 2722<br/>E-mail: centralderelacionamento@lpht.com.br<br/><br/>Website: <a href=\"https://lpht.com.br/\">https://lpht.com.br/</a>"
            }
        },
        "STATUS_PROGRAM": {
            "1": { "PT": "Rascunho", "EN": "Draft" },
            "2": { "PT": "Rascunho", "EN": "Draft" },
            "3": { "EN": "Awaiting Franchise Manager approval", "PT": "Aguardando aprovação do Gerente de Franquia" },
            /**************************** MUDEI O Gerente de Marca da Região PARA Gerente de Desenvolvimento de Mercado ****************************/
            /**************************** MUDEI O Gerente de Desenvolvimento de Mercado PARA Gerente de Marketing Regional *************************/
            "4": { "EN": "Awaiting Regional Marketing Manager approval", "PT": "Aguardando aprovação do Gerente de Marketing Regional" },
            /**************************** MUDEI O Gerente de Marca da Região PARA Gerente de Desenvolvimento de Mercado ****************************/
            /**************************** MUDEI O Gerente de Desenvolvimento de Mercado PARA Gerente de Marketing Regional *************************/
            /*"5": { "EN": "Awaiting Franchisee approval ", "PT": "Aguardando aprovação do Franqueado" },*/
            "5": { "EN": "Awaiting completion of Focal Point's data", "PT": "Aguardando preenchimento dos dados do Focal Point" },
            /**************************** ALTEREI AQUI NO NÚMERO 05 P/ PREENCHIMENTO DO DADOS DO FOCAL POINT ****************************/
            "6": { "EN": "Awaiting Customer acceptance", "PT": "Aguardando aceite do Cliente" },
            "7": { "EN": "Ended", "PT": "Finalizado" },
            "8": { "EN": "Canceled", "PT": "Cancelado" },
            "9": { "EN": "Declined", "PT": "Recusado" },
            "10": { "EN": "Customer Accepted", "PT": "Aceite Realizado" },
            "11": { "EN": "Waiting for Approval", "PT": "Aguardando Aprovação" },
            "12": { "EN": "Paid ", "PT": "Pagamento Realizado" },
            "40": { "PT": "Rascunho", "EN": "Draft" },
            "41": { "PT": "Rascunho", "EN": "Draft" },
            "42": { "EN": "Awaiting Franchise Manager approval", "PT": "Aguardando aprovação do Gerente de Franquia" },
            "43": { "EN": "Declined by Franchise Manager", "PT": "Recusado pelo Gerente de Franquia" },
            "44": { "EN": "Awaiting Reginal Marketing Manager approval", "PT": "Aguardando aprovação do Gerente de Marketing Regional" },
            "45": { "EN": "Declined by Regional Marketing Manager", "PT": "Recusado pelo Gerente de Marketing Regional" },
            "46": { "EN": "Awaiting completion of Focal Point's data", "PT": "Aguardando preenchimento dos dados do Focal Point" },
            "47": { "EN": "Awaiting completion of Legal Representative data", "PT": "Aguardando preenchimento dos dados do Representante Legal" },
            "48": { "EN": "Awaiting Customer acceptance", "PT": "Aguardando aceite do Cliente" },
            "49": { "EN": "Customer Accepted", "PT": "Aceite Realizado" },
        },
        "STATUS_PROGRAM_MODAL": {
            "1": { "PT": "Rascunho", "EN": "Draft" },
            "2": { "PT": "Rascunho", "EN": "Draft" },
            "3": { "EN": "Awaiting Franchise Manager approval", "PT": "Aguardando aprovação do Gerente de Franquia" },
            /**************************** MUDEI O Gerente de Marca da Região PARA Gerente de Desenvolvimento de Mercado ****************************/
            /**************************** MUDEI O Gerente de Desenvolvimento de Mercado PARA Gerente de Marketing Regional *************************/
            "4": { "EN": "Awaiting Regional Marketing Manager approval", "PT": "Aguardando aprovação do Gerente de Marketing Regional" },
            /**************************** MUDEI O Gerente de Marca da Região PARA Gerente de Desenvolvimento de Mercado ****************************/
            /**************************** MUDEI O Gerente de Desenvolvimento de Mercado PARA Gerente de Marketing Regional *************************/
            /*"5": { "EN": "Awaiting Franchisee approval ", "PT": "Aguardando aprovação do Franqueado" },*/
            "5": { "EN": "Awaiting completion of Focal Point's data", "PT": "Aguardando preenchimento dos dados do Focal Point" },
            /**************************** ALTEREI AQUI NO NÚMERO 05 P/ PREENCHIMENTO DO DADOS DO FOCAL POINT ****************************/
            "6": { "EN": "Awaiting Customer acceptance", "PT": "Aguardando aceite do Cliente" },
            "7": { "EN": "Ended", "PT": "Finalizado" },
            "8": { "EN": "Canceled", "PT": "Cancelado" },
            "9": { "EN": "Declined", "PT": "Recusado" },
            "10": { "EN": "Customer Accepted", "PT": "Aceite Realizado" },
            "11": { "EN": "Waiting for Approval", "PT": "Aguardando Aprovação" },
            "12": { "EN": "Paid ", "PT": "Pagamento Realizado" },
            "40": { "PT": "Rascunho", "EN": "Draft" },
            "41": { "PT": "Rascunho", "EN": "Draft" },
            "42": { "EN": "Inserted Goal", "PT": "Meta Inserida" },
            "43": { "EN": "Declined by Franchise Manager", "PT": "Recusado pelo Gerente de Franquia" },
            "44": { "EN": "Approved by Franchise Manager", "PT": "Aprovado pelo Gerente de Franquia" },
            "45": { "EN": "Declined by Regional Marketing Manager", "PT": "Recusado pelo Gerente de Marketing Regional" },
            "46": { "EN": "Approved by Regional Marketing Manager", "PT": "Aprovado pelo Gerente de Marketing Regional" },
            "47": { "EN": "Filling in the Focal Point Data", "PT": "Preenchimento dos Dados do Focal Point" },
            "48": { "EN": "Filling in the Data of the Legal Representative", "PT": "Preenchimento dos Dados do Representante Legal" },
            "49": { "EN": "Customer Accepted", "PT": "Aceite Realizado pelo Cliente" },
        },
        "STATUS_PROGRAM_ACTION": {
            "1": { "EN": "Request approvals", "PT": "Solicitar aprovações" },
            "2": { "EN": "Request approvals", "PT": "Solicitar aprovações" },
            "3": { "EN": "Approve goal", "PT": "Aprovar meta" },
            "4": { "EN": "Approve goal", "PT": "Aprovar meta" },
            "5": { "EN": "Check Users", "PT": "Verificar Usuários" },
            "6": { "EN": "Accept term and participate", "PT": "Aceitar termo e participar" },
            "7": { "PT": "" },
            "8": { "PT": "" },
            "9": { "PT": "" },
            "10": { "PT": "" },
            "40": { "EN": "Request approvals", "PT": "Solicitar aprovações" },
            "41": { "EN": "Request approvals", "PT": "Solicitar aprovações" },
            "42": { "EN": "Approve Goal", "PT": "Aprovar Meta" },
            "43": { "EN": "Decline Goal", "PT": "Recusar Meta" },
            "44": { "EN": "Approve Goal", "PT": "Aprovar Meta" },
            "45": { "EN": "Decline Goal", "PT": "Recusar Meta" },
            "46": { "EN": "Check Users", "PT": "Verificar Usuários" },
            "47": { "EN": "Check Users", "PT": "Verificar Usuários" },
            "48": { "EN": "Accept term and participate", "PT": "Aceitar termo e participar" },
            "49": { "EN": "", "PT": "" },
        },
        "STATUS_PROGRAM_DESC": {
            "1": {
                "EN": "Only Administrative users can view this goal. To request approvals and release to the Customer, fill in all the information and click on the \"Request approvals\" button",
                "PT": "Apenas usuários Administrativos conseguem visualizar esta meta. Para solicitar aprovações e liberar para o Cliente, preencha todas as informações e clique no botão \"Solicita aprovações\""
            },
            "2": {
                "EN": "Only Administrative users can view this goal. To request approvals and release to the Customer, fill in all the information and click on the \"Request approvals\" button",
                "PT": "Apenas usuários Administrativos conseguem visualizar esta meta. Para solicitar aprovações e liberar para o Cliente, preencha todas as informações e clique no botão \"Solicita aprovações\""
            },
            "3": {
                "EN": "The visibility of this program is restricted to only LongPing employees, such as Administrative users, Franchise Managers and Market Development Managers. All goal approvals are still required for Customers to have access",
                "PT": "A visibilidade deste programa está restrita à apenas colaboradores LongPing, como usuários Administrativos, Gerentes de Franquias e Gerentes de Desenvolvimento de Mercado. Ainda é necessário todas as aprovações da meta para que os Clientes tenham acesso."
            },
            "4": {
                "EN": "The visibility of this program is restricted to only LongPing employees, such as Administrative users, Franchise Managers and Market Development Managers. All goal approvals are still required for Customers to have access",
                "PT": "A visibilidade deste programa está restrita à apenas colaboradores LongPing, como usuários Administrativos, Gerentes de Franquias e Gerentes de Desenvolvimento de Mercado. Ainda é necessário todas as aprovações da meta para que os Clientes tenham acesso."
            },
            "5": {
                "EN": "Fill in the Focal Point data by clicking on the green \"Check Users\" button. The visibility of this program is restricted, Customers will only be able to access it after completing this action.",
                "PT": "Preencha os dados do Focal Point clicando no botão verde \"Verificar Usuários\". A visibilidade deste programa está restrita, Clientes só poderão ter acesso após a conclusão desta ação."
            },
            "6": {
                "EN": "Awaiting agreement letter acceptance by the Legal Representative. In order for it to approve, it is necessary to register its user.",
                "PT": "Aguardando aceite da carta acordo pelo Representante Legal. Para realizar o aceite, é necessário cadastrar seu usuário."
            },
            "9": {
                "EN": "The goal was disapproved by the participants, it will be necessary to change its parameters and request a new round of approvals.",
                "PT": "A meta foi reprovada pelos participantes, será necessário alterar seus paramêtros e solicitar uma nova rodada de aprovações."
            },
            "10": {
                "EN": "Goal and program terms accepted.",
                "PT": "Termos da meta e do programa aceitos."
            },
            "41": {
                "EN": "Only Administrative users can view this goal. To request approvals and release to the Customer, fill in all the information and click on the \"Request approvals\" button",
                "PT": "Apenas usuários Administrativos conseguem visualizar esta meta. Para solicitar aprovações e liberar para o Cliente, preencha todas as informações e clique no botão \"Solicitar aprovações\""
            },
            "40": {
                "EN": "Only Administrative users can view this goal. To request approvals and release to the Customer, fill in all the information and click on the \"Request approvals\" button",
                "PT": "Apenas usuários Administrativos conseguem visualizar esta meta. Para solicitar aprovações e liberar para o Cliente, preencha todas as informações e clique no botão \"Solicita aprovações\""
            },
            "42": {
                "EN": "The visibility of this program is restricted to only LongPing employees, such as Administrative users, Franchise Managers and Market Development Managers. All goal approvals are still required for Customers to have access",
                "PT": "A visibilidade deste programa está restrita à apenas colaboradores LongPing, como usuários Administrativos, Gerentes de Franquias e Gerentes de Desenvolvimento de Mercado. Ainda é necessário todas as aprovações da meta para que os Clientes tenham acesso."
            },
            "43": {
                "EN": "The goal was disapproved by the participants, it will be necessary to change its parameters and request a new round of approvals.",
                "PT": "A meta foi reprovada pelos participantes, será necessário alterar seus paramêtros e solicitar uma nova rodada de aprovações."
            },
            "44": {
                "EN": "The visibility of this program is restricted to only LongPing employees, such as Administrative users, Franchise Managers and Market Development Managers. All goal approvals are still required for Customers to have access",
                "PT": "A visibilidade deste programa está restrita à apenas colaboradores LongPing, como usuários Administrativos, Gerentes de Franquias e Gerentes de Desenvolvimento de Mercado. Ainda é necessário todas as aprovações da meta para que os Clientes tenham acesso."
            },
            "45": {
                "EN": "The goal was disapproved by the participants, it will be necessary to change its parameters and request a new round of approvals.",
                "PT": "A meta foi reprovada pelos participantes, será necessário alterar seus paramêtros e solicitar uma nova rodada de aprovações."
            },
            "46": {
                "EN": "Fill in the Focal-Point data by clicking on the green button \"Check Users\". After this action, click on the Confirm button, then the Focal-Point will be able to fill in the data of the Legal Representative to make the acceptance to participate in the Program and generate the Letter of Agreement.",
                "PT": "Preencha os dados do Focal-Point clicando no botão verde \"Verificar Usuários\". Após esta ação, clique em no botão Confirmar, então o Focal-Point poderá preencher os dados do Representante Legal para fazer o aceite para participar do Programa e gerar a Carta Acordo."
            },
            "47": {
                "EN": "Fill in the Legal Representative data by clicking on the green button \"Check Users\". After this action, click on the Confirm button, then the Legal Representative can make the acceptance to participate in the Program and generate the Letter of Agreement.",
                "PT": "Preencha os dados do Representante Legal clicando no botão verde \"Verificar Usuários\". Após esta ação, clique em no botão Confirmar, então o Representante Legal poderá fazer o aceite para participar do Programa e gerar a Carta Acordo."
            },
            "48": {
                "EN": "Awaiting agreement letter acceptance by the Legal Representative.",
                "PT": "Aguardando aceite da carta acordo pelo Representante Legal."
            },
            "49": {
                "EN": "Goal and program terms accepted.",
                "PT": "Termos da meta e do programa aceitos."
            }
        },
        "STATUS_PROGRAM_WARNING": {
            "1": { "PT": "." },
            "2": { "PT": "." },
            "3": { "EN": "Upon requesting approval, Franshise and Market Development Managers will have access to the information for this goal. Franchisees and Customers still can't access it.", "PT": "Ao solicitar a aprovação, Gerentes de Franquia e de Desenvolvimento de Mercado terão acesso as informações desta meta. Franqueados e Clientes ainda não conseguem acessa-la" },
            "4": { "EN": "When approving this step, the Regional Marketing Manager will have access to this information and must also approve it before this goal is available to Franchisees and Customers. ", "PT": "Ao aprovar esta etapa, o Gerente de Marketing Regional terá acesso a essas informações e deve aprová-la também antes que esta meta esteja disponível para Franqueados e Clientes." },
            "5": { "EN": "When approving this step, the Franchisee will have access to fill in the customer's Focal Point data.", "PT": "Ao aprovar esta etapa, o Franqueado terá acesso para preenchimento dos dados do Focal Point do cliente.”" },
            "6": { "EN": "Upon completion of this step, the customer's Focal Point will have access to fill in the Legal Representative information.", "PT": "Ao concluir esta etapa, o Focal Point do cliente terá acesso para preenchimento dos dados do Representante Legal." },
            "7": { "EN": "Upon closing this item, other users will no longer be able to access it", "PT": "Ao encerrar este item, outros usuários não poderão mais acessá-lo" },
            "8": { "EN": "By cancel this item, other users will no longer be able to access it", "PT": "Ao cancelar este item, outros usuários não poderão mais acessá-lo" },
            "9": { "EN": "When disapproving this item, the Administrative user will be notified to make any necessary changes. For a new approval, this user must republish this item.", "PT": "Ao recusar este item, o usuário Administrativo será notificado para que seja realizado qualquer alteração necessária. Para uma nova aprovação, este usuário deve publicar este item novamente." },
            "10": { "EN": "By accepting, you agree to all terms related to the Incentive Program in question and state that you understand its conditions and characteristics.", "PT": "Ao aceitar, você concorda com todos os termos relacionados ao Programa de Incentivo em questão e afirma que entende as condições e características do mesmo." },
            "40": { "PT": "." },
            "41": { "PT": "." },
            "42": { "EN": "Upon requesting approval, Franshise and Market Development Managers will have access to the information for this goal. Franchisees and Customers still can't access it.", "PT": "Ao solicitar a aprovação, Gerentes de Franquia e de Desenvolvimento de Mercado terão acesso as informações desta meta. Franqueados e Clientes ainda não conseguem acessa-la" },
            "43": { "EN": "When disapproving this item, the Administrative user will be notified to make any necessary changes. For a new approval, this user must republish this item.", "PT": "Ao recusar este item, o usuário Administrativo será notificado para que seja realizado qualquer alteração necessária. Para uma nova aprovação, este usuário deve publicar este item novamente." },
            "44": { "EN": "When approving this step, the Regional Marketing Manager will have access to this information and must also approve it before this goal is available to Franchisees and Customers. ", "PT": "Ao aprovar esta etapa, o Gerente de Marketing Regional terá acesso a essas informações e deve aprová-la também antes que esta meta esteja disponível para Franqueados e Clientes." },
            "45": { "EN": "When disapproving this item, the Administrative user will be notified to make any necessary changes. For a new approval, this user must republish this item.", "PT": "Ao recusar este item, o usuário Administrativo será notificado para que seja realizado qualquer alteração necessária. Para uma nova aprovação, este usuário deve publicar este item novamente." },
            "46": { "EN": "When approving this step, the Franchisee will have access to fill in the customer's Focal Point data.", "PT": "Ao aprovar esta etapa, o Franqueado terá acesso para preenchimento dos dados do Focal Point do cliente.”" },
            "47": { "EN": "By confirming, you declare that the information of the users informed is correct.", "PT": "Ao confirmar, você declara que as informações dos usuários informadas estão corretas." },
            "48": { "EN": "By confirming, you declare that the information of the users informed is correct.", "PT": "Ao confirmar, você declara que as informações dos usuários informadas estão corretas." },
            "49": { "EN": "By accepting, you agree to all terms related to the Incentive Program in question and state that you understand its conditions and characteristics.", "PT": "Ao aceitar, você concorda com todos os termos relacionados ao Programa de Incentivo em questão e afirma que entende as condições e características do mesmo." },
        },
        "STATUS_PROGRAM_REFUND": {
            "1": { "PT": "Rascunho", "EN": "Draft" },
            "2": { "PT": "Rascunho", "EN": "Draft" },
            "3": { "EN": "Awaiting Franchise Manager approval", "PT": "Aguardando aprovação do Gerente de Franquia" },
            /**************************** MUDEI O Gerente de Marca da Região PARA Gerente de Desenvolvimento de Mercado ****************************/
            /**************************** MUDEI O Gerente de Desenvolvimento de Mercado PARA Gerente de Marketing Regional *************************/
            "4": { "EN": "Awaiting Regional Marketing Manager approval", "PT": "Aguardando aprovação do Gerente de Marketing Regional" },
            /**************************** MUDEI O Gerente de Marca da Região PARA Gerente de Desenvolvimento de Mercado ****************************/
            /**************************** MUDEI O Gerente de Desenvolvimento de Mercado PARA Gerente de Marketing Regional *************************/
            /*"5": { "EN": "Awaiting Franchisee approval ", "PT": "Aguardando aprovação do Franqueado" },*/
            "5": { "EN": "Awaiting completion of Focal Point's data", "PT": "Aguardando preenchimento dos dados do Focal Point" },
            /**************************** ALTEREI AQUI NO NÚMERO 05 P/ PREENCHIMENTO DO DADOS DO FOCAL POINT ****************************/
            "6": { "EN": "Awaiting Customer acceptance", "PT": "Aguardando aceite do Cliente" },
            "7": { "EN": "Ended", "PT": "Finalizado" },
            "8": { "EN": "Canceled", "PT": "Cancelado" },
            "9": { "EN": "Declined", "PT": "Em Revisão" },
            "10": { "EN": "Approved", "PT": "Aprovado" },
            "11": { "EN": "Waiting for Approval", "PT": "Aguardando Aprovação" },
            "12": { "EN": "Paid ", "PT": "Pagamento Realizado" },
        },
        "PROGRAM_RESULTS_STATUS_REFUND": {
            "1": { "PT": "Rascunho", "EN": "Draft" },
            "2": { "PT": "Rascunho", "EN": "Draft" },
            "3": { "EN": "Awaiting validation of result.", "PT": "Aguardando validação do resultado." },
            "4": { "EN": "Awaiting validation of result.", "PT": "Aguardando validação do resultado." },
            "5": { "EN": "Awaiting Regional Marketing Manager approval", "PT": "Aguardando aprovação do Gerente de Marketing Regional" },
            "6": { "EN": "Awaiting Customer acceptance", "PT": "Aguardando aceite do Cliente" },
            "7": { "EN": "Ended", "PT": "Finalizado" },
            "8": { "EN": "Canceled", "PT": "Cancelado" },
            "9": { "EN": "Declined", "PT": "Em Revisão" },
            "10": { "EN": "Result validated.", "PT": "Resultado validado." },
            "11": { "EN": "Result", "PT": "Resultado" },
            "12": { "EN": "Result", "PT": "Resultado" },
            //"12": { "EN": "Payment made", "PT": "Realizado o pagamento" },
        },
        "STATUS_PROGRAM_3": {
            "1": { "PT": "Rascunho", "EN": "Draft" },
            "2": { "PT": "Rascunho", "EN": "Draft" },
            "3": { "EN": "Released", "PT": "Liberado" },
            "6": { "EN": "Published", "PT": "Publicado" },
            "7": { "EN": "Ended", "PT": "Finalizado" },
            "8": { "EN": "Canceled", "PT": "Cancelado" },
            "9": { "EN": "Declined", "PT": "Recusado" },
        },
        "STATUS_PROGRAM_DO": {
            "1": { "EN": "Criar", "PT": "Criar" },
            "2": { "EN": "Edit", "PT": "Editar" },
            "3": { "EN": "Publish", "PT": "Publicar" },
            "4": { "EN": "Validate", "PT": "Validar" },
            "5": { "EN": "Validate", "PT": "Validar" },
            "6": { "EN": "Launch", "PT": "Lançar" },
            "7": { "EN": "Finalize", "PT": "Finalizar" },
            "8": { "EN": "Cancel", "PT": "Cancelar" },
            "9": { "EN": "Deny", "PT": "Recusar" },
            "10": { "EN": "Accept", "PT": "Aceitar" },
        },
        "STATUS_PROGRAM2": {
            "1": { "PT": "Rascunho", "EN": "Draft" },
            "2": { "PT": "Rascunho", "EN": "Draft" },
            "3": { "EN": "Published", "PT": "Publicado" },
            "4": { "EN": "Validated 1/2", "PT": "Validado 1/2" },
            "5": { "EN": "Validated 2/2", "PT": "Validado 2/2" },
            "6": { "EN": "Launched", "PT": "Lançado" },
            "7": { "EN": "Ended", "PT": "Finalizado" },
            "8": { "EN": "Canceled", "PT": "Cancelado" },
            "9": { "EN": "Declined", "PT": "Recusado" },
            "10": { "EN": "Accepted", "PT": "Aprovado" },
        },
        "PROGRAM_STATUS_PROGRAM_DESC": {
            "1": {
                "EN": "Only Administrative users can view this program. To release it, fill in all the information and click the button \"Release\"",
                "PT": "Apenas usuários Administrativos conseguem visualizar este programa. Para liberá-lo, preencha todas as informações e clique no botão \"Liberar\""
            },
            "2": {
                "EN": "Only Administrative users can view this program. To release it, fill in all the information and click the button below:",
                "PT": "Apenas usuários Administrativos conseguem visualizar este programa. Para liberá-lo, preencha todas as informações e clique no botão a seguir:"
            },
            //  "Apenas usuários Administrativos conseguem visualizar este item. É necessário sua publicação para que outros usuários consiguam visualizar." },
            "3": {
                "EN": "The visibility of this program is restricted to only LongPing employees, such as Administrative users, Franchise Managers and Market Development Managers. Customer and Franchisee users, for example, are unable to view this program.",
                "PT": "A visibilidade deste programa está restrita à apenas colaboradores LongPing, como usuários Administrativos, Gerentes de Franquias e Gerentes de Desenvolvimento de Mercado. Usuários de Clientes e Franqueados, por exemplo, não conseguem visualizar este programa."
            },
            "6": {
                "EN": "This program is available to all users participating in the process.",
                "PT": "Este programa está disponivel para todos os usuários participantes do processo."
            },
        },
        "PROGRAM_STATUS_PROGRAM_ACTION": {
            "1": {
                "EN": "Release program",
                "PT": "Liberar programa"
            },
            "2": {
                "EN": "Release program",
                "PT": "Liberar programa"
            },
            //  "Apenas usuários Administrativos conseguem visualizar este item. É necessário sua publicação para que outros usuários consiguam visualizar." },
            "3": {
                "EN": "Publish program",
                "PT": "Publicar programa"
            },
            // "A visibilidade deste registro está restrita à apenas colaboradores LongPing, como usuários Administrativos, Gerentes de Franquias e Gerentes de Desenvolvimento de Mercado. Usuários de Clientes, por exemplo, não conseguem visualizar este." },
            "4": { "PT": "" },
            // "O Gerente de Franquia aprovou este item. Ainda é necessário a aprovação do Gerente Marketing Regional para sua liberação." },
            "5": { "PT": "" },
            // "Validado 2/2" },
            "6": { "PT": "" },
            // "Lançado" },
            "7": { "PT": "" },
            // "Finalizado" },
            "8": { "PT": "" },
            // "Cancelado" },
            "9": { "PT": "" },
            // "Recusado" },
            "10": { "PT": "" },
            // "Aprovado" },
        },
        "REFUND_STATUS_PROGRAM_ACTION_A": {
            "1": {
                "EN": "Request approval",
                "PT": "Solicitar aprovação"
            },
            "2": {
                "EN": "Request approval",
                "PT": "Solicitar aprovação"
            },
            "4": {
                "EN": "Approve request",
                "PT": "Aprovar solicitação"
            },
            "11": {
                "EN": "Approve request",
                "PT": "Aprovar solicitação"
            },
            "12": {
                "EN": "Inform payment",
                "PT": "Informar pagamento"
            },
        },
        "REFUND_STATUS_PROGRAM_ACTION_B": {
            "4": {
                "EN": "Decline request",
                "PT": "Recusar solicitação"
            },
            "11": {
                "EN": "Decline request",
                "PT": "Recusar solicitação"
            },
        },
        "REFUND_STATUS_PROGRAM_RESULT_A": {
            "1": {
                "EN": "Request approval",
                "PT": "Solicitar aprovação"
            },
            "2": {
                "EN": "Request approval",
                "PT": "Solicitar aprovação"
            },
            "4": {
                "EN": "Approve request",
                "PT": "Aprovar solicitação"
            },
            "5": {
                "EN": "Approve request",
                "PT": "Aprovar solicitação"
            },
            "9": {
                "EN": "Send to the Franchise Manager",
                "PT": "Enviar para o Gerente de Franquia",
            },
            "10": {
                "EN": "Send to Franchisee",
                "PT": "Enviar para o Cliente"
            },
            "11": {
                "EN": "Payment of result",
                "PT": "Pagamento de resultado"
            },
        },
        "REFUND_STATUS_PROGRAM_RESULT_B": {
            "4": {
                "EN": "Decline request",
                "PT": "Recusar solicitação"
            },
            "5": {
                "EN": "Decline request",
                "PT": "Recusar solicitação"
            },
            "11": {
                "EN": "Decline request",
                "PT": "Recusar solicitação"
            },
        },
        "REFUND_STATUS_PROGRAM_DESC": {
            "1": {
                "EN": "This is just a draft. In order for the payment or refund to be effected, it is necessary to request approval from LongPing. To do this, click \"Request Approval\".",
                "PT": "Isso é apenas um rascunho. Para que o pagamento ou reembolso seja efetuado, é necessário solicitar a aprovação da LongPing. Para isso, clique em \"Solicitar Aprovação\"."
            },
            "2": {
                "EN": "This is just a draft. In order for the payment or refund to be effected, it is necessary to request approval from LongPing. To do this, click \"Request Approval\".",
                "PT": "Isso é apenas um rascunho. Para que o pagamento ou reembolso seja efeutado, é necessário solicitar a aprovação da LongPing. Para isso, clique em \"Solicitar Aprovação\"."
            },
            "4": {
                "EN": "Awaiting approval for release.",
                "PT": "Aguardando aprovação para liberação."
            },
            "9": {
                "EN": "For corrections and changes, it is necessary to edit this request as directed in the Observation field below.",
                "PT": "Para correções e alterações, é necessário editar esta solicitação conforme orientação no campo Observação abaixo."
            },
            "10": {
                "EN": "LongPing accepted the request. Payment will be informed shortly.",
                "PT": "A LongPing aceitou o a solicitação. O pagamento será informado em breve."
            },
            "11": {
                "EN": "The request for payment of the Qualitative Award has been sent and is being analyzed.",
                "PT": "A solicitação de pagamento do Prêmio Qualitativo foi enviada e está em análise."
            },
            "12": {
                "EN": "The payment has been completed.",
                "PT": "O pagamento foi concluído."
            }
        },
        "ACTION_PLAN_STATUS_PROGRAM_DESC": {
            "1": {
                "EN": "This is just a draft. In order for the customer to have access to this award, it is necessary to request approval from the Market Development Manager. To do this, click the \"Request Approval\" button.",
                "PT": "Isso é apenas um rascunho. Para que o cliente tenha acesso a este prêmio, é preciso solicitar aprovação do Gerente de Marketing Regional. Para isso, clique no botão \"Solicitar Aprovação\"."
            },
            "2": {
                "EN": "This is just a draft. In order for the customer to have access to this award, it is necessary to request approval from the Regional Marketing Manager. To do this, click the \"Request Approval\" button.",
                "PT": "Isso é apenas um rascunho. Para que o cliente tenha acesso a este prêmio, é preciso solicitar aprovação do Gerente de Marketing Regional. Para isso, clique no botão \"Solicitar Aprovação\"."
            },
            "4": {
                "EN": "Awaiting approval for release.",
                "PT": "Aguardando aprovação para liberação."
            },
            "9": {
                "EN": "The action plan was rejected by the brand development manager for that region. Edit the parameters to request a new approval.",
                "PT": "O plano de ação foi recusado pelo Gerente de Marketing Regional. Edite os parâmetros para solicitar uma nova aprovação."
            },
            "10": {
                "EN": "To use the award, click \"Attach Files\" in the lower right corner of this screen.",
                "PT": "Para utilizar o prêmio, clique em \"Incluir Arquivos\" no canto inferior direito desta tela."
            }
        },
        "PROGRAM_RESULTS_STATUS_DESC": {
            "1": {
                "EN": "This is just a draft. For the customer to have access to this information, the validation process must be completed. To do this, click on the \"Validation\" button.",
                "PT": "Isso é apenas um rascunho. Para que o cliente tenha acesso a esta informação, é preciso concluir o processo de validação. Para isso, clique no botão \"Validação\"."
            },
            "4": {
                "EN": "Awaiting validation for release.",
                "PT": "Aguardando validação para liberação."
            },
            "5": {
                "EN": "Awaiting approval for release.",
                "PT": "Aguardando aprovação para liberação."
            },
            "9": {
                "EN": "The results was rejected by the franchise manager. Edit the parameters to request a new approval.",
                "PT": "O resultado foi recusado pelo Gerente Franquia. Edite os parâmetros para solicitar uma nova aprovação."
            },
            "10": {
                "EN": "This process of releasing the Admin release for the Customer to view the results",
                "PT": "Está no processo de liberação do Admin liberar para o Cliente vizualizar os resultados."
            },
            "11": {
                "EN": "It is free for the Client to view these results",
                "PT": "Está liberado para o Cliente vizualizar seus resultados."
            },
            "12": {
                "EN": "It is free for the Client to view these results",
                "PT": "Está liberado para o Cliente vizualizar seus resultados."
            },
        },
        "PROGRAM_STATUS_PROGRAM_WARNING": {
            "3": {
                "EN": "The visibility of this record will be available to all LongPing employees, such as Administrative users, Franchise Managers and Regional Marketing Manager. Users of Customers and Franchisees, for example, would still not be able to view this.",
                "PT": "A visibilidade deste registro estará disponível a todos os colaboradores LongPing, como usuários Administrativos, Gerentes de Franquia e Gerente de Marketing Regional. Usuários de Clientes e Franqueados, por exemplo, ainda não conseguiriam visualizar este."
            },
            "6": {
                "EN": "The visibility of this program will be available to all types of users who are part of this process, including customers and franchisees",
                "PT": "A visibilidade deste programa estará disponível a todos os tipos de usuários que fazem parte deste processo, inclusive Clientes e Franqueados"
            },
        },
        "ACTION_PLAN_STATUS_PROGRAM_WARNING": {
            "4": {
                "EN": "The action plan will be sent to the Regional Market Manager for approval. Only after this approval will the Customer have access.",
                "PT": "O plano de ação será enviado para o Gerente de Marketing Regional para que seja aprovado. Só após esta aprovação que o Cliente terá acesso."
            },
            "4confirm": {
                "EN": "If the amount used is less than the maximum investment, you cannot modify this plan. Are you sure you want to confirm?",
                "PT": "Se o valor utilizado for menor que o investimento máximo, você não poderá modificar esse plano. Tem certeza que deseja confirmar?"
            },
            "9": {
                "EN": "Upon disapprove this item, the Franchisee will be notified and will have to make changes before he can submit a new round of approvals.",
                "PT": "Ao recursar este item, o Franqueado será notificado e terá que realizar alterações antes de poder submeter uma nova rodada de aprovações."
            },
            "10": {
                "EN": "When approving, the Client can use the award according to the approved amount.",
                "PT": "Ao aprovar, o Cliente poderá utilizar o prêmio de acordo com a verba aprovada."
            },
        },
        "PROGRAM_RESULTS_STATUS_WARNING": {
            "1": {
                "EN": "Are you sure you want to send it to the customer?\nuse this sending option if you have evidence of email validation.",
                "PT": "Tem certeza que deseja enviar para o cliente?\nUtilizar essa opção de envio apenas se tiver evidência de validação por e-mail."
            },
            "4": {
                "EN": "The result will be sent for validation by the franchise manager, only after this approval will the customer have access to the information on this screen.",
                "PT": "O Resultado será enviado para validação pelo gerente de franquia, somente após esta aprovação o cliente terá acesso a informação nesta tela."
            },
            "9": {
                "EN": "Upon disapprove this item, the Admin will be notified and will have to make changes before he can submit a new round of approvals.",
                "PT": "Ao recursar este item, o Admin será notificado e terá que realizar alterações antes de poder submeter uma nova rodada de aprovações."
            },
            "10": {
                "EN": "when approving, the admin will be notified to release the results to the customer.",
                "PT": "Ao aprovar, o admin será notificado para liberar o resultados para o cliente."
            },
            "11": {
                "EN": "when approving, the customer will have access to the result of it.",
                "PT": "Ao aprovar, o cliente terá aceso ao resultado dele."
            },
            "12": {
                "EN": "By clicking “confirm”, the customer will have access to their result.",
                "PT": "Ao clicar em “confirmar”, o cliente terá acesso ao resultado dele."
            },
        },
        "REFUND_STATUS_PROGRAM_WARNING": {
            "11": {
                "EN": "The request will be sent to LongPing and will be subject to analysis.",
                "PT": "A solicitação será enviada para LongPing e estará sujeita a análise."
            },
            "9": {
                "EN": "When disapproving this item, the Customer will be notified and he will have to make a new payment or refund request in case he needs any changes.",
                "PT": "Ao recusar este item, o Cliente será notificado e o mesmo terá que fazer uma nova solicitação de reembolso ou pagamento caso necessite de alguma alteração."
            },
            "10": {
                "EN": "Upon approval, the Customer will be notified that the payment or refund will be made.",
                "PT": "Ao aprovar, o Cliente será notificado que o pagamento ou reembolso será realizado."
            },
            "12": {
                "EN": "Upon informing the payment, the Customer will be notified that the payment has been made.",
                "PT": "Ao informar o pagamento, o Cliente será notificado que o pagamento foi realizado."
            },
        },
        "password": {
            "new": { "EN": "New Password", "PT": "Nova Senha" },
            "request": {
                "EN": "To request a password change or the creation of a new one, it is necessary to inform the registered email:",
                "PT": "Para solicitar a alteração de senha ou a criação de uma nova, é necessário informar o e-mail cadastrado:"
            },
            "error": {
                "EN": "It was not possible to request a password change. Please try again later.",
                "PT": "Não foi possível solicitar a alteração de senha. Por favor, tente novamente mais tarde."
            },
            "success": {
                "EN": "Your request was successful. Please follow the instructions sent by email to continue.",
                "PT": "Sua solicitação foi realizada com sucesso. Por favor, siga as instruções enviados por e-mail para dar continuidade."
            },
            "notallowed": {
                "EN": "It is not possible to change your user's password. To do this, contact technical support.",
                "PT": "Não é possível alterar a senha do seu usuário. Para isso, entre em contato com suporte técnico."
            },
            "body": {
                "EN": "To continue creating a new password, it is necessary to inform the same email address where you received this link. Then enter the new password and confirmation.",
                "PT": "Para dar continuidade a criação de uma nova de senha de acesso, é necessário informar o mesmo de endereço de e-mail em que você recebeu este link. Em seguida, informe a nova senha e sua confirmação."
            },
            "warning": {
                "EN": "Your password must contain at least 8 characters composed of upper and lower case letters, numbers and special characters (Ex .: # $ @% ....).",
                "PT": "Sua senha deve conter no mínimo 8 caracteres compostos de letras maiúsculas e minúsculas, números e caracteres especiais (Ex.: # $ @ %....)."
            },
            "confirm": { "EN": "Confirm password", "PT": "Confirmar senha" },
        },
        "DOC_TYPE": {
            "1": { "PT": "CPF" },
            "2": {
                "PT": "CNPJ"
            },
        },
    };

    // CREATED = 1,
    // EDITED = 2,
    // PUBLISHED = 3,
    // VALIDATED_GF = 4,
    // VALIDATED_GDM = 5,
    // LAUNCHED = 6,
    // ENDED = 7,
    // CANCELED = 8,
    // Declined = 9
    // ACCEPTED = 10

    static GetLabel(target, placeholder) {
        var l = global.applanguage;
        var c = target.split("."), i = 0, t = Labels.values;
        while (i < c.length && t != null) {
            t = typeof (t[c[i]]) !== "undefined" && t[c[i]] != null ? t[c[i]] : null;
            if (typeof t === "function") t = t();
            i++;
        }

        if (t != null) {
            if (typeof t === "string") return t;
            else if (typeof t[l] === "string") return t[l];
            else if (typeof t[Labels.availables[0]] === "string") return t[Labels.availables[0]];
            for (const key in t)
                if (typeof t[key] === "string")
                    return t[key];
        }
        return typeof placeholder === "string" ? placeholder : "N/A LABEL";
    }

    static toggleLanguage(target) {
        var c = Labels.availables.indexOf(typeof target === "string" ? target.toUpperCase() : global.applanguage);
        if (typeof target === "string" && c > -1) c = target.toUpperCase();
        else if (c > -1 && c < Labels.availables.length - 1) c = Labels.availables[c + 1];
        else c = Labels.availables[0];

        global.applanguage = c;
        AppStorage.SetStorageKey("language", c);
        return c;
    }
}
